import moment from 'moment';
import { useEffect, useState } from 'react';
import { ChartSmoothLine } from '../../../../../components/chart';
// import getFormatMessage from '../../../../../locales/get-format-message';
import { IBillList } from '../../../../../model/billing-center/balance';
import '../../billing-management/style.scss';
import classNames from 'classnames';
import getFormatMessage from '../../../../../locales/get-format-message';

interface IProps {
  readonly recentMonthsList: IBillList[];
  readonly dateRange: string;
}

export const RecentYearsChartComponent = (props: IProps) => {
  const [isYear, setIsYear] = useState<boolean>(true);
  const { recentMonthsList, dateRange } = props;
  const currentMonth = moment().format('YYYY-MM');
  const previousYearMonth = moment(currentMonth)
    .subtract(isYear ? 11 : 5, 'months')
    .startOf('month')
    .format('YYYY-MM');

  // 累计，排序
  const monthlyData: Record<string, number> = {};
  recentMonthsList?.forEach((item) => {
    const month = moment(item.bill_end_date).format('YYYY-MM');
    if (monthlyData[month]) {
      monthlyData[month] += parseFloat(item.total_cost);
    } else {
      monthlyData[month] = parseFloat(item.total_cost);
    }
  });
  // 生成从previousYearMonth到currentMonth的月份
  const startMonth = moment(previousYearMonth).startOf('month');
  const endMonth = moment(currentMonth).startOf('month');
  const monthsSet: Set<string> = new Set(); // 明确指定类型为 Set<string>

  while (startMonth.isBefore(endMonth) || startMonth.isSame(endMonth)) {
    monthsSet.add(startMonth.format('YYYY-MM'));
    startMonth.add(1, 'month');
  }

  const xAxis: string[] = Array.from(monthsSet).sort(); // 转换为数组排序
  const xAxisLabels: string[] = xAxis.map((month) =>
    moment(month).format('MM')
  );
  const seriesData = xAxis.map((month) => {
    return monthlyData[month] !== undefined ? monthlyData[month] : null;
  });
  // console.log('xAxisLabels:', xAxisLabels);
  // console.log('seriesData:', seriesData);
  // const wei=[null, null, null, 11, null, null, null, null, 46.66, 72.56, 0,null];

  useEffect(() => {
    if (dateRange) {
      const sixMonthsAgo = moment().subtract(6, 'months').format('YYYY-MM');
      const oneYearAgo = moment().subtract(1, 'years').format('YYYY-MM');
      // 判断当前月份是否在近半年和近一年之间
      const isWithinLastSixMonths =
        moment(dateRange).isAfter(sixMonthsAgo) &&
        moment(dateRange).isBefore(moment());
      const isWithinLastYear =
        moment(dateRange).isAfter(oneYearAgo) &&
        moment(dateRange).isBefore(moment());
      if (!isWithinLastSixMonths && isWithinLastYear) {
        setIsYear(true);
      }
    }
  }, [dateRange]);

  return (
    <div className="overview-months">
      <div className="overview-title">
        <div className="overview-title-left">
          {getFormatMessage('bill_management_consumption_trend')}
        </div>
        <div className="overview-title-right">
          <div
            className={classNames(
              'overview-title-btn-left',
              isYear ? '' : 'overview-title-btn-active'
            )}
            onClick={() => setIsYear(false)}
          >
            {getFormatMessage('bill_management_months')}
          </div>
          <div
            className={classNames(
              'overview-title-btn-right',
              isYear ? 'overview-title-btn-active' : ''
            )}
            onClick={() => setIsYear(true)}
          >
            {getFormatMessage('bill_management_year')}
          </div>
        </div>
      </div>
      {xAxisLabels.length > 0 && seriesData.length > 0 && (
        <ChartSmoothLine
          className="overview-months-chart"
          style={{ height: 220, width: '100%' }}
          xAxisLabel={xAxisLabels}
          seriesData={[seriesData]}
          // defaultMonth={dateRange ? dateRange.split('-')[1] : ''}
        />
      )}
    </div>
  );
};
